export default {
    'Alert(s)': 'Alerte(s)',
    'Set': 'Déclenchée',
    'Cleared': 'Levée',
    'Message': 'Message'
}